<template>
  <div class="store_wrapper mb-5">
    <h4 class="main_color">تعديل فرع</h4>
    <form @submit.prevent="validateForm">
      <div class="container">
        <div class="row">
          <!-- START:: MAP -->
          <div class="col-12 fadeIn">
            <div class="large-map">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  id="autocomplete_ar"
                  placeholder="ابحث على الخريطة"
                  @click="getAddressAr"
                />
              </div>
              <GmapMap
                :center="coordinates_to_edit"
                :zoom="7"
                :draggable="true"
                map-type-id="terrain"
              >
                <GmapMarker
                  :position="coordinates_to_edit"
                  :clickable="true"
                  :draggable="true"
                  @dragend="updateMarker($event.latLng)"
                />
                />
              </GmapMap>
            </div>
            <div class="col-lg-12 py-0 mt-5">
              <div class="input_wrapper top_label">
                <textarea
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model="data.location"
                />
                <label for="name_input" class="form-label"> وصف الموقع </label>
              </div>
            </div>

            <!-- Start:: Is Active -->
            <!-- <div class="col-12 py-0">
                <v-checkbox
                  :label="$t('forms.labels.is_active')"
                  v-model="data.is_active"
                  color="success"
                ></v-checkbox>
              </div> -->
            <!-- End:: Is Active -->
          </div>
          <!-- END:: MAP -->
        </div>
      </div>

      <div class="buttons_wrapper">
        <button class="button_style_1" :disabled="btnIsLoading">
          {{ $t("forms.submit") }}
          <span class="btn_loader" v-if="btnIsLoading"></span>
        </button>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  props: ["id", "clear_fileds"],
  data() {
    return {
      branch: JSON.parse(localStorage.getItem("zoz_store_branch")),
      data: {
        location: null,
      },
      center: {
        lat: null,
        lng: null,
      },

      storeInfo: null,

      markers: null,
      coordinates_to_edit: { lat: 0, lng: 0 },
      countries: [],
      cities: [],
      // ========== Loading
      btnIsLoading: false,
    };
  },
  watch: {
    "data.country"(value) {
      if (value) {
        this.getCities(value.id);
      }
    },
    clear_fileds() {
      this.data = {
        location: null,
      };
      this.center = {
        lat: null,
        lng: null,
      };
      this.markers = null;
      this.coordinates_to_edit = { lat: 0, lng: 0 };
    },
  },
  methods: {
    updateCoordinates(location) {
      console.log(location);
      this.updateData = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },

    clickMethod(m) {
      this.center = m.position;
    },
    // END:: UPDATE LOCATION
    updateMarker(location) {
      this.coordinates_to_edit = {
        lat: location.lat(),
        lng: location.lng(),
      };

      // this.henlo = location.lat();
    },
    // ============== Get User Location
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          // this.$axios({
          //   method: "get",
          //   url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=AIzaSyAITrPfT5r_qmCm_8ekZyPmnebGo8o_r18`,
          // })
          //   .then((res) => {
          //     console.log(res.data.results[0].formatted_address);
          //   })
          //   .catch(() => {});

          this.markers = [
            {
              position: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
            },
          ];
          this.center = this.markers[0].position;

          this.coordinates_to_edit.lat = this.center.lat;
          this.coordinates_to_edit.lng = this.center.lng;
        });
      }
    },
    setRows() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: `show_place/${this.$route.params.id}`,
      })
        .then((res) => {
          this.loading = false;

          this.storeInfo = res.data.data;
          this.data.lat = this.branch.lat;
          this.data.lng = this.branch.lng;
          this.data.location = this.branch.location;
          this.coordinates_to_edit.lat = this.branch.lat;
          this.coordinates_to_edit.lng = this.branch.lng;
          this.markers = [
            {
              position: {
                lat: this.branch.lat,
                lng: this.branch.lng,
              },
            },
          ];
          this.center = this.markers[0].position;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // START:: G-MAP GET ADDRESS
    getAddressAr() {
      var self = this;
      var input = document.getElementById("autocomplete_ar");
      var searchBox = new google.maps.places.SearchBox(input);
      searchBox.addListener("places_changed", function () {
        var places = searchBox.getPlaces();
        if (places.length == 0) {
          return;
        }
        var bounds = new google.maps.LatLngBounds();
        places.forEach(function (place) {
          bounds.extend(place.geometry.location);
          place.geometry.location.lat();
          place.geometry.location.lng();
          place.formatted_address;
          // self.data.address = place.formatted_address;
          // console.log();
          self.coordinates_to_edit = {
            lat: Number(place.geometry.location.lat()),
            lng: Number(place.geometry.location.lng()),
          };
          // self.markers[0].position.lat = place.geometry.location.lat();
          // self.markers[0].position.lng = place.geometry.location.lat();
        });
      });
    },
    // Uplode Image
    uplodeImg_1(obj) {
      this.data.image = obj;
    },
    // ============ Get Select Lists Data
    validateForm() {
      this.btnIsLoading = true;

      if (!this.data.location) {
        this.$iziToast.error({
          timeout: 2000,
          message: "وصف الموقع مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },
    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("ar[name]", this.storeInfo.ar.name);
      submit_data.append(
        "place_category_id",
        this.storeInfo.place_categeory_id
      );
      submit_data.append("ar[name]", this.storeInfo.ar.name);
      submit_data.append("en[name]", this.storeInfo.en.name);
      submit_data.append("location", this.data.location);
      submit_data.append("lat", this.coordinates_to_edit.lat);
      submit_data.append("lng", this.coordinates_to_edit.lng);
      submit_data.append("_method", "PUT");
      this.$axios({
        method: "POST",
        url: `place/store/${this.$route.query.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$emit("branchAdded");
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  async created() {
    this.setRows();
  },
};
</script>
<style lang="scss" scoped>
.store_wrapper {
  padding: 1rem;
  @include mainShadow;
  border-radius: 15px;
}
</style>
